import parse from "date-fns/parse";
import format from "date-fns/format";
import { ActivityAvailabilityDto } from "../dtos";
import dinero, { Dinero } from "dinero.js";
import { prepPrice } from "../../utils";

export class ActivityAvailability {
  private dtoFormat = "yyyy-MM-dd HH:mm:ss";
  dateFormat = "dd-MM-yyyy";
  timeFormat = "HH:mm";

  date = new Date();
  dateStr = "";
  timeStr = "";
  reservationData: {
    slots: {
      slot_id: number;
      capacity: number;
      instance_start_time: string; //"2020-12-22 15:30:00";
      instance_end_time: string; //"2020-12-22 15:30:00";
      slot_order: number;
    }[];
    price: {
      person_type_id: number;
      price: number;
      vat: number;
      price_for_temp_reservation: {
        slot_id: number;
        time_slots_prices: {
          [dateAndTime: string]: {
            price: number;
            vat: number;
            discount: number | string;
          };
        };
      }[];
    };
  } = {
    slots: [],
    price: {
      vat: -1,
      price: -1,
      person_type_id: -1,
      price_for_temp_reservation: [],
    },
  };
  totalTax: Dinero = dinero();
  totalPrice: Dinero = dinero();

  constructor(dto: ActivityAvailabilityDto & { date: string }) {
    const date = parse(dto.date, this.dtoFormat, this.date);
    this.date = date;
    this.dateStr = format(date, this.dateFormat);
    this.timeStr = format(date, this.timeFormat);
    this.reservationData = {
      slots: dto.slots,
      price: dto.price,
    };
    this.totalTax = dinero({ amount: prepPrice(dto.price.vat) });
    this.totalPrice = dinero({ amount: prepPrice(dto.price.price) });
  }
}
